import { obterClientePostHog } from 'app/services/posthog/posthog-client';
import { environment } from 'environments/environment';

import { type FlagReader, resolveModuleMigration } from './module-migration';

// Sem cliente (SDK desligado, carregando ou com falha) não há valor a ler: devolve
// undefined e o resolvedor aplica o default de build da chave.
const readFromClient: FlagReader = (key, defaultValue) =>
  obterClientePostHog()?.isFeatureEnabled(key, { defaultValue });

// Guarda só a função de leitura, nunca um valor lido: o cache e a invalidação por
// identidade ficam por conta do SDK.
let flagReader: FlagReader = readFromClient;

/** Decide se o módulo da chave é servido pela página React. Nunca lança. */
export function isModuleMigrated(flagKey: string): boolean {
  // Defaults lidos na hora da chamada, e não no carregamento do módulo, para que o spec
  // possa variá-los e restaurá-los sem recarregar a ponte.
  return resolveModuleMigration(flagKey, flagReader, {
    moduleDefault: environment.migrationFlags[flagKey] === true,
    killSwitchDefault: environment.migrationKillSwitch === true,
  });
}

/** Substitui o leitor de flag. Não usar em código de produção. */
export function setFlagReaderForTests(reader: FlagReader): void {
  flagReader = reader;
}

/** Restaura o leitor de produção. Não usar em código de produção. */
export function resetFlagReaderForTests(): void {
  flagReader = readFromClient;
}
